import {Outlet, createFileRoute, redirect} from '@tanstack/react-router';
import {getDoc} from 'firebase/firestore';
import {getTeacherFeedbackRoleDocRef} from '@cip/core/firebase/client';
import {ForbiddenError} from '../../../../errors';

export const Route = createFileRoute('/_authenticated/courses/$courseId')({
  async beforeLoad({context, params}) {
    const {user} = context.auth;
    if (!user) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing redirects
      throw redirect({to: '/sign-in'});
    }

    const roleDoc = await getDoc(
      getTeacherFeedbackRoleDocRef({uid: user.uid, courseId: params.courseId}),
    );
    if (!roleDoc.exists()) {
      throw new ForbiddenError(
        `You don't have access to course "${params.courseId}".`,
      );
    }
  },
  component: () => <Outlet />,
});
